exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-photo[data-v-5ba199f0]{width:2rem;height:2rem;margin:-.375rem 0}.navbar-light .navbar-brand[data-v-5ba199f0],.navbar-light .navbar-brand[data-v-5ba199f0]:hover{color:rgba(0,0,0,.9);text-decoration:none}.nav-item .dropdown-menu a[data-v-5ba199f0],.nav-item .dropdown-menu a[data-v-5ba199f0]:hover{font-size:16px;color:#16181b}.md-theme-default a[data-v-5ba199f0]:not(.md-button),.theme--light.v-list .v-list__tile--link[data-v-5ba199f0],.theme--light.v-list .v-list__tile--link[data-v-5ba199f0]:hover{color:rgba(0,0,0,.87);text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ba199f0","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Navbar.vue
// module id = +CZW
// module chunks = 16